import * as React from "react";
import { accountsPageLabels, Contents } from "../Resoures/Contents";
import * as classNames from "classNames";
import { Navigator } from "../../Shared/Wizards/Entities/Navigator";
import { BaseComponent } from "../../../react-core/Html/BaseComponent";
import { UserStore } from "../Stroes/Variable";
import { Action } from "../Actions/Action";
import { Urls } from "../Urls";
import { Permission } from "../../Shared/Permission/Permission";
import { DLUAccountPages, isDLU } from "../Resoures/DashboardContents";
import { UserClaim } from "../../../Wrap/Constants/Enums/UserClaim";
import { User } from "../../../Wrap/Models/Models/User/User";
import { ContextStore } from "../../../react-core/Flux/Variables";
import { getEnumValues } from "../../../react-core/Utils/Enum";
import { ContextType } from "../../../Wrap/Constants/Enums/ContextType";
import { HierarchyIdHelper } from "../../Shared/Common/HierarchyIdHelper";
import { Lightbox, LightboxType } from "../../../react-core/Html/Components/Lightbox";
import { HierarchyLevelName } from "../../../Wrap/Constants/Enums/HierarchyLevelName";
import { CustomerNewProductLink } from "../../../Wrap/Models/Models/Customer/CustomerNewProductLink";
import { SelectAccountLightbox } from "./SelectAccountLightbox";
import { CoachMarkerContext } from "../../Shared/CoachMarkers/CoachMarkerContext";
import { Scroll } from "../../../react-core/Utils/Scroll";
import CoachMarker from "../../Shared/CoachMarkers/CoachMarker";
import { PortfolioDashboardStore } from "./Clients/PortfolioDashboard/Store/Variable";
import { ClientAccount } from "../../../Wrap/Models/Domains/Account/SlAccounts/ClientAccount";
import { isAdminSpecificPage } from "../../Admin/Dashboard/AdminDashboard";
import { JsonDateParser } from "../../../react-core/Utils/JsonDateParser";
import { LegadoAction } from "./Clients/PortfolioDashboard/Components/Legado/Action/LegadoAction";
import { LegadoConfigStore } from "./Clients/PortfolioDashboard/Store/Variables";
import { CommonHelper } from "../../../react-core/Helpers/CommonHelper";

interface ISecuredMainNavigationProps {
    onClick?: (method: string, parameters?: any) => void;
}

interface ISecuredMainNavigationState {
    notificationsCount?: number;
    userInfo?: User;
    showAccountLightbox?: boolean;
    links: CustomerNewProductLink[];
    errorMsg: string;
    allAccounts: ClientAccount[];
    isLegadoEnabled: boolean;
}

enum MainNavigationSideMenu {
    Dashboard = "dashboard",
    Clients = "customer",
    ToolLiterature = "tools-and-literature",
    BusinessManagemnt = "business-management",
    Admin = "admin",
    Profile = "profile",
}

export class SecuredMainNavigation extends BaseComponent<ISecuredMainNavigationProps, ISecuredMainNavigationState> {
    constructor(props: any) {
        super(props);
        this.state = {
            notificationsCount: 3,
            showAccountLightbox: false,
            links: [],
            errorMsg: null,
            allAccounts: PortfolioDashboardStore.getData(),
            userInfo: null,
            isLegadoEnabled: null,
        };

        this.subscribeToStore(PortfolioDashboardStore, () => this.onUnderlyingAcountsStoreChange());
        this.subscribeToStore(UserStore, () => this.onUserStoreChange());
        this.subscribeToStore(LegadoConfigStore, () => this.loadLegadoConfig());
    }

    componentDidMount() {
        this.loadLegadoConfig();
        const userInfo = UserStore.getUserInfo();
        if (userInfo) {
            this.setState({ userInfo: userInfo });
        } else {
            Action.getUser();
        }
    }

    onUnderlyingAcountsStoreChange() {
        this.setState({ allAccounts: PortfolioDashboardStore.getData() });
    }

    onUserStoreChange() {
        this.setState({ userInfo: UserStore.getUserInfo() });
    }

    private getTabIndex(): MainNavigationSideMenu {
        if (isAdminSpecificPage()) {
            return MainNavigationSideMenu.Admin;
        }

        let tab = MainNavigationSideMenu.Dashboard;
        if (isDLU()) {
            tab = MainNavigationSideMenu.Dashboard;
        } else if (DLUAccountPages.includes(window.location.pathname)) {
            tab = MainNavigationSideMenu.Clients;
        } else {
            const url = Urls.getCurrentUrl();

            const sideMenus = getEnumValues(MainNavigationSideMenu);
            for (const ele of sideMenus) {
                if (ele.toLowerCase() === url.toLowerCase()) {
                    tab = ele as MainNavigationSideMenu;
                    break;
                }
            }
        }
        return tab;
    }

    private onMenuClick(_index: MainNavigationSideMenu) {
        let goto = Urls.get().main.Dashboard;
        let url = "/wpadviser/en-gb/dashboard/home/main/";
        ContextStore.flushStore();
        switch (_index) {
            case MainNavigationSideMenu.BusinessManagemnt:
                goto = Urls.get().main.BusinessManagement;
                url = url + "business-management";
                break;
            case MainNavigationSideMenu.ToolLiterature:
                goto = Urls.get().main.ToolAndLiterature;
                url = url + "tools-and-literature";
                break;
            case MainNavigationSideMenu.Admin:
                goto = Urls.get().main.Admin;
                url = url + "admin";
                break;
            case MainNavigationSideMenu.Clients:
                goto = Urls.get().main.Client;
                url = url + "customer";
                break;
            case MainNavigationSideMenu.Profile:
                goto = Urls.get().main.Settings;
                url = url + "settings";
                break;
            default:
                url = url + "dashboard";
                break;
        }

        if (this.props.onClick) {
            this.props.onClick(Contents.Method_CloseMenu);
        }
        if (isDLU()) {
            window.location.assign(url);
        } else {
            Navigator.navigateTo(goto);
        }
    }

    private getNavigationElementTitleAndCss(): { title: string; css: string } {
        const index = this.getTabIndex();
        const id = ContextStore.getUrlParamsHierarchyId(ContextType.Customer);
        let title = accountsPageLabels.newClient;
        const css = "main-cta";

        switch (index) {
            case MainNavigationSideMenu.Clients:
                title =
                    id && this.state.allAccounts?.length > 0
                        ? accountsPageLabels.newProduct
                        : accountsPageLabels.newClient;
                break;
            case MainNavigationSideMenu.BusinessManagemnt:
                title = accountsPageLabels.newClient;
                break;
            default:
                break;
        }
        return { title: title, css: css };
    }

    private getNavigationElement(): JSX.Element {
        const { title, css } = this.getNavigationElementTitleAndCss();
        const id = ContextStore.getUrlParamsHierarchyId(ContextType.Customer);
        const { hierarchyLevel, entityId } = HierarchyIdHelper.generateHierarchyId(id);

        if (title === accountsPageLabels.newProduct) {
            return (
                <div key="product">
                    {UserStore.getUserInfo()?.IsReadOnly != true && (
                        <Permission userClaim={UserClaim.AdviserPortalNewQuoteNewBusinessReadWrite}>
                            <button
                                onClick={() => {
                                    if (hierarchyLevel == HierarchyLevelName.Account) {
                                        this.setState({
                                            errorMsg: "New product journey not available for this type of Account.",
                                            showAccountLightbox: true,
                                        });
                                    } else if (hierarchyLevel == HierarchyLevelName.Customer) {
                                        Action.getNewProductLink(entityId, (links: CustomerNewProductLink[]) => {
                                            if (links.length == 0) {
                                                this.setState({
                                                    errorMsg:
                                                        "New product journey not available for this type of Account.",
                                                    showAccountLightbox: true,
                                                });
                                            } else if (links.length == 1) {
                                                if (links[0].IsActive) {
                                                    window.location.assign(links[0].Link);
                                                } else {
                                                    this.setState({
                                                        errorMsg:
                                                            "New product journey not available for this type of Account.",
                                                        showAccountLightbox: true,
                                                    });
                                                }
                                            } else {
                                                this.setState({ links: links, showAccountLightbox: true });
                                            }
                                        });
                                    }
                                }}
                                className={css}
                            >
                                <span className="icon"></span>
                                <span>{title}</span>
                            </button>
                        </Permission>
                    )}
                </div>
            );
        }
        return (
            <div key="client">
                <CoachMarker coachMarkerKey="business-management-run-report" />
                {UserStore.getUserInfo()?.IsReadOnly != true && (
                    <Permission userClaim={UserClaim.AdviserPortalNewClientReadWrite}>
                        <button
                            onClick={() => {
                                if (isDLU()) {
                                    window.location.assign(
                                        `/wpadviser/en-gb/dashboard/home/main/client/addclient/client-type`
                                    );
                                } else {
                                    Navigator.navigateTo(Urls.get().ClientType);
                                }
                            }}
                            className={css}
                        >
                            <span className="icon"></span>
                            <span>{title}</span>
                        </button>
                    </Permission>
                )}
            </div>
        );
    }

    private getClassName() {
        if (isAdminSpecificPage()) {
            return accountsPageLabels.adminClassName;
        }

        const url = Urls.getCurrentUrl();
        switch (url) {
            case accountsPageLabels.dashboardRouteLabel:
                return accountsPageLabels.dashboardClassName;
            case accountsPageLabels.accountsRouteLabel:
                return accountsPageLabels.accountsClassName;
            case accountsPageLabels.clientsRouteLabel:
                return accountsPageLabels.clientsClassName;
            case accountsPageLabels.businessManagementRouteLabel:
                return accountsPageLabels.businessInsightClassName;
            case accountsPageLabels.toolsAndLiteratureRouteLabel:
                return accountsPageLabels.toolsAndLiteratureClassName;
            case accountsPageLabels.adminRouteLabel:
                return accountsPageLabels.adminClassName;
        }
    }

    private getSectionBarParameters() {
        const className = this.getClassName();
        const mainItemsDOM = document.querySelectorAll(".main-items")[0] as HTMLElement;
        let activeItemDOM = null;
        if (mainItemsDOM) {
            activeItemDOM = mainItemsDOM.querySelectorAll(`.${className}`)[0] as HTMLElement;
        }
        if (activeItemDOM) {
            return {
                sectionBarTop: activeItemDOM.offsetTop,
                sectionBarHeight: activeItemDOM.offsetHeight,
                sectionBarOpacity: 1,
            };
        } else {
            return {
                sectionBarTop: null,
                sectionBarHeight: 0,
                sectionBarOpacity: 0,
            };
        }
    }

    private renderAccountsLightbox() {
        const id = ContextStore.getUrlParamsHierarchyId(ContextType.Customer);
        const { entityId } = HierarchyIdHelper.generateHierarchyId(id);
        return (
            <>
                {this.state.showAccountLightbox && (
                    <Lightbox
                        show={this.state.showAccountLightbox}
                        title={this.state.errorMsg ? "" : "Please select an account"}
                        onClose={() => this.setState({ showAccountLightbox: false, errorMsg: null })}
                        type={LightboxType.Modal}
                        cssWrapper="is-default-lightbox is-narrow"
                    >
                        <SelectAccountLightbox
                            customerId={entityId}
                            links={this.state.links}
                            errorMsg={this.state.errorMsg}
                            displayNewBusiness={!PortfolioDashboardStore.hasInProgressAccounts()}
                        />
                    </Lightbox>
                )}
            </>
        );
    }

    private handleAppStoreClick() {
        (window as any).AppStore.navigateToStore();
    }

    private loadLegadoConfig() {
        const data = LegadoConfigStore.getLegadoConfigInfo();

        if (CommonHelper.isNullOrEmpty(data)) {
            LegadoAction.isLegadoEnabled();
        } else {
            this.setState({ isLegadoEnabled: data });
        }
    }

    public render(): JSX.Element {
        const userInfo = UserStore.getUserInfo();
        if (
            JsonDateParser.isValidDate(userInfo?.PasswordExpiredDate) &&
            userInfo?.PasswordExpiredDate <= JsonDateParser.toJsonDateNoOffset(new Date())
        ) {
            return null;
        }

        const { notificationsCount } = this.state;
        const _NotificationElement =
            notificationsCount < 0 ? (
                <span className="icon" aria-hidden={true} />
            ) : (
                <span className="icon-with-notification-count">
                    <span className="bell-icon icon-anim" aria-hidden={true} />
                    <span className="count icon-anim">{notificationsCount}</span>
                </span>
            );
        const { sectionBarTop, sectionBarHeight, sectionBarOpacity } = this.getSectionBarParameters();
        let clientInitials = "Profile";
        if (this.state.userInfo?.ClientName && this.state.userInfo?.ClientName.includes(" ")) {
            const clientNames = this.state.userInfo?.ClientName?.trim().split(" ");
            clientInitials = clientNames[0]?.substr(0, 1) + clientNames[clientNames.length - 1]?.substr(0, 1);
            clientInitials = clientInitials?.toUpperCase();
            if (clientInitials.trim() == "") {clientInitials = "DU";}
        }
        const index = this.getTabIndex();

        const isAppStoreEnabled = this.state.userInfo?.IsAppStoreEnabledForUser;

        const isAdmin = ContextStore.getContext()?.isAdminUser;

        return (
            <nav aria-labelledby="nav1">
                <div id="nav1" className="sr-only">
                    Secured main navigation
                </div>
                <div className="secured-main-navigation">
                    <CoachMarker coachMarkerKey="secured-main-navigation" />

                    {this.getNavigationElement()}
                    {this.renderAccountsLightbox()}
                    <ul className="main-items">
                        <span
                            className="section-bar"
                            style={{
                                top: `${sectionBarTop}px`,
                                height: `${sectionBarHeight}px`,
                                opacity: sectionBarOpacity,
                            }}
                            aria-hidden={true}
                        />
                        <Permission
                            userClaim={[
                                UserClaim.AdviserPortalWorkFlowCanView,
                                UserClaim.AdviserPortalNotificationCanView,
                            ]}
                        >
                            <li>
                                <button
                                    onClick={(e) => this.onMenuClick(MainNavigationSideMenu.Dashboard)}
                                    className={classNames("item dashboard", {
                                        active: index == MainNavigationSideMenu.Dashboard,
                                    })}
                                    aria-current={index == MainNavigationSideMenu.Dashboard ? "page" : false}
                                >
                                    <span className="icon" aria-hidden={true} />
                                    Dashboard
                                </button>
                            </li>
                        </Permission>
                        <Permission userClaim={UserClaim.AdviserPortalAccountSearchCanView}>
                            <li>
                                <button
                                    onClick={(e) => this.onMenuClick(MainNavigationSideMenu.Clients)}
                                    className={classNames("item customers", {
                                        active: index == MainNavigationSideMenu.Clients,
                                    })}
                                    aria-current={index == MainNavigationSideMenu.Clients ? "page" : false}
                                >
                                    <span className="icon" aria-hidden={true} />
                                    Clients
                                </button>
                            </li>
                        </Permission>
                        <Permission userClaim={UserClaim.AdviserPortalBusinessManagementReadWrite}>
                            <li>
                                <button
                                    onClick={(e) => this.onMenuClick(MainNavigationSideMenu.BusinessManagemnt)}
                                    className={classNames("item insight", {
                                        active: index == MainNavigationSideMenu.BusinessManagemnt,
                                    })}
                                    aria-current={index == MainNavigationSideMenu.BusinessManagemnt ? "page" : false}
                                >
                                    <span className="icon" aria-hidden={true} />
                                    Business management
                                </button>
                            </li>
                        </Permission>
                        <li>
                            <button
                                onClick={(e) => this.onMenuClick(MainNavigationSideMenu.ToolLiterature)}
                                className={classNames("item literature", {
                                    active: index == MainNavigationSideMenu.ToolLiterature,
                                })}
                                aria-current={index == MainNavigationSideMenu.ToolLiterature ? "page" : false}
                            >
                                <span className="icon" aria-hidden={true} />
                                Tools and literature
                            </button>
                        </li>
                        {isAdmin && (
                            <li>
                                <button
                                    onClick={(e) => this.onMenuClick(MainNavigationSideMenu.Admin)}
                                    className={classNames("item admin", {
                                        active: index == MainNavigationSideMenu.Admin,
                                    })}
                                    aria-current={index == MainNavigationSideMenu.Admin ? "page" : false}
                                >
                                    <span className="icon" aria-hidden={true} />
                                    Admin
                                </button>
                            </li>
                        )}
                        {/*( this.state.isLegadoEnabled &&
                            <Permission userClaim={UserClaim.AdviserPortalLegadoDocumentHubCanView}>
                                <li>
                                    <button
                                        onClick={() => LegadoAction.get( 
                                            [], 
                                            (url) => {
                                            window.open(url, '_blank').focus();
                                        })}
                                        className={classNames("item library", {
                                            active: false
                                        })}
                                        // aria-current={index == MainNavigationSideMenu.LegadoDocs ? "page" : false}
                                    >
                                        <span className="icon" aria-hidden={true} />
                                        Document hub
                                    </button>
                                </li>
                            </Permission>    
                        )*/}
                    </ul>
                    <div className="additional">
                        <button
                            className="profile"
                            title="Profile settings"
                            onClick={() => {
                                this.onMenuClick(MainNavigationSideMenu.Profile);
                            }}
                        >
                            <CoachMarker coachMarkerKey="profile" />
                            <span className="sr-only">Profile</span>
                            <span className="initials">{clientInitials}</span>
                        </button>
                        {/* <CoachMarkerContext.Consumer>
                            {(coachMarkerContext) =>
                                coachMarkerContext.step && (
                                    <div>
                                        <CoachMarker coachMarkerKey="platform-tips" />
                                        <CoachMarker coachMarkerKey="no-tips" />
                                        <button
                                            className="coach-marker-tutorial"
                                            title="Platform tips"
                                            onClick={() => {
                                                Scroll.scrollTop();
                                                coachMarkerContext.reset();
                                            }}
                                        >
                                            <span className="sr-only">Coach marker</span>
                                            <span
                                                className={`icon ${
                                                    coachMarkerContext.hasUnread == false ? "" : "unread"
                                                }`}
                                                aria-hidden="true"
                                            />
                                        </button>
                                    </div>
                                )
                            }
                        </CoachMarkerContext.Consumer> */}
                        {isAppStoreEnabled && (
                            <>
                                <CoachMarker coachMarkerKey="appstore" />
                                <a className="applications-pad" onClick={this.handleAppStoreClick}>
                                    <span className="sr-only">App Store</span>
                                    <span className="icon" aria-hidden="true" />
                                </a>
                            </>
                        )}
                    </div>
                </div>
            </nav>
        );
    }
}
